const en_ja =
{
  "ALL": "全て",
  "About Clinic": "クリニックについて",
  "About Doctor": "医師について",
  "Actions": "アクション",
  "Activate": "活性化",
  "Active": "アクティブ",
  "Active Coupons": "アクティブなクーポン",
  "Active Doctors": "稼働中の医師",
  "Active Pharmacies": "有効な薬局",
  "Active Status": "有効なステータス",
  "Add Coupon": "クーポンを追加",
  "Add Doctor": "医師を追加",
  "Add FAQ": "よくある質問を追加",
  "Add Image": "画像を追加",
  "Add Images": "画像を追加",
  "Add Manuals": "取扱説明書を追加",
  "Rows per page:": "ページあたりの行数:",
  "Add Medicine": "薬を追加",
  "Add Pharmacy": "薬局を追加",
  "Add Product": "商品を追加",
  "Add Videos": "ビデオを追加",
  "Add medication": "薬を追加",
  "Add new Doctor": "新しい医師を追加",
  "Address": "住所",
  "Admin Portal": "管理ポータル",
  "Age": "年齢",
  "Amount": "金額",
  "Answer": "回答",
  "Auto Approve slot:": "自動承認スロット：",
  "Avg Revenue/Pharmacies": "平均収益/薬局",
  "Basic Details": "基本情報",
  "Cancel": "キャンセル",
  "Canceled Orders": "キャンセルされた注文",
  "Cannot create slots for past dates": "過去の日付にはスロットを作成できません",
  "Change Password": "パスワードの変更",
  "Choose Image": "画像の選択",
  "Choose a Image": "画像の選択",
  "City": "都市",
  "Clear All": "すべてクリア",
  "Click on the map or drag the marker to set the clinic location": "地図をクリックするか、マーカーをドラッグして診療所の場所を設定してください",
  "Clinic Address": "クリニックの住所",
  "Clinic Information": "クリニック情報",
  "Clinic Name": "クリニック名",
  "Completed Orders": "完了した注文",
  "Confirm Password": "パスワードを確認",
  "Confirm your new password": "新しいパスワードを確認",
  "Consultation Notes": "診察メモ",
  "Contact": "連絡先",
  "Contact Details": "連絡先詳細",
  "Coordinates:": "座標：",
  "Could not update Status": "ステータスを更新できませんでした",
  "Could not update coupon status": "クーポンステータスを更新できませんでした",
  "Coupon Code": "クーポンコード",
  "Coupon Name": "クーポン名",
  "Coupons": "クーポン",
  "Create Prescription": "処方箋を作成",
  "Creating Prescription...": "処方箋を作成中...",
  "Current Image": "現在の画像",
  "Current Password": "現在のパスワード",
  "Custom Package": "カスタムパッケージ",
  "Date": "日付",
  "Deactivate": "非アクティブ化",
  "deactivate": "非アクティブ化する",
  "activate": "活性化",
  "Description": "説明",
  "Discard Changes": "変更を破棄",
  "Discount Value": "割引額",
  "Doctor": "医師",
  "Doctor Profile": "医師のプロフィール",
  "Doctor activated successfully": "医師を有効化しました",
  "Doctor added successfully!": "医師を追加しました！",
  "Doctor deactivated successfully": "医師を無効化しました",
  "Doctor updated successfully!": "医師を更新しました！",
  "Doctor with similar credentails already exists!": "同様の資格を持つ医師が既に存在します！",
  "Dose*": "用量*",
  "Drag and drop the image": "画像をドラッグ＆ドロップ",
  "Duration*": "期間*",
  "Edit Doctor": "医師を編集",
  "Edit Profile": "プロフィールを編集",
  "Email": "メール",
  "Email Address": "メールアドレス",
  "End Date": "終了日",
  "Enter the code sent to your email and set your new password": "メールで送られてきたコードを入力し、新しいパスワードを設定してください",
  "Enter the doctor's information and assign them to a clinic": "医師情報を入力し、クリニックに割り当ててください",
  "Enter your new password": "新しいパスワードを入力してください",
  "Error could not create slots!": "スロットの作成エラー！",
  "Error updating slot": "スロットの更新エラー",
  "Error while adding Doctor": "医師の追加エラー",
  "Error while updating Doctor": "医師の更新エラー",
  "Error while updating doctor status": "医師のステータス更新エラー",
  "Experience": "経験",
  "Experience (years)": "経験（年数）",
  "FAQs": "よくある質問",
  "Failed to fetch coupons": "クーポンの取得失敗",
  "Failed to load clinic data": "クリニックデータの読み込み失敗",
  "Failed to load pharmacies": "薬局データ読み込み失敗",
  "Failed to publish product": "商品の公開失敗",
  "Failed!": "失敗！",
  "First Name": "名",
  "Format: number + unit (e.g., 5mg, 2.5ml, 10units)": "形式：数値 + 単位（例：5mg、2.5ml、10ユニット）",
  "Frequency*": "頻度*",
  "From:": "から：",
  "Full Name": "フルネーム",
  "Gender": "性別",
  "Go to Today": "本日へ",
  "Height (cm)": "身長（cm）",
  "Here's Your Clinic Management Overview For Today": "本日のクリニック管理概要",
  "Highlight this product in a featured section.": "この商品を特集セクションでハイライト表示",
  "History": "履歴",
  "Images": "画像",
  "Inactive": "無効",
  "Inactive Pharmacies": "無効な薬局",
  "Join Date": "入職日",
  "Joining Date": "入職日",
  "Keep Editing": "編集を続ける",
  "Landline No.": "固定電話番号",
  "Landline Number": "固定電話番号",
  "Last Name": "姓",
  "Loading Google Maps...": "Google Mapsを読み込み中...",
  "Loading coupons...": "クーポンを読み込み中...",
  "Loading pharmacies...": "薬局を読み込み中...",
  "Loading prescription data...": "処方データを読み込み中...",
  "Loading prescription history...": "処方履歴を読み込み中...",
  "Loading profile...": "プロフィールを読み込み中...",
  "Logout": "ログアウト",
  "Manuals": "取扱説明書",
  "Medical ID": "医療ID",
  "Medications:": "処方薬：",
  "Medicine name*": "薬剤名*",
  "Method": "投与方法",
  "Minimum Order Value": "最低注文金額",
  "Name": "名前",
  "New Onboardings": "新規入職",
  "New Orders": "新規注文",
  "New Password": "新しいパスワード",
  "New Prescription": "新規処方箋",
  "No Doctors Found": "該当する医師は見つかりません",
  "No Payment Data": "支払いデータはありません",
  "No coupons available": "利用可能なクーポンがありません",
  "No description available": "説明はありません",
  "No doctors have been added to the system yet.": "システムに医師が追加されていません",
  "No doctors match your search criteria.": "検索条件に一致する医師はいません",
  "No payment transactions found for this period.": "この期間の支払い取引は見つかりませんでした",
  "No payment transactions match your search criteria.": "検索条件に一致する支払い取引はありません",
  "No pharmacies available": "利用可能な薬局はありません",
  "No pharmacy data found": "薬局データが見つかりません",
  "No prescription history found": "処方履歴が見つかりません",
  "No recent activity": "最近の活動はありません",
  "No slots created for this date": "この日付に作成されたスロットはありません",
  "No slots found for this date": "この日付にスロットが見つかりません",
  "Not specified": "指定なし",
  "Notification": "通知",
  "OPEN": "営業中",
  "OTP sent to your email successfully": "ワンタイムパスワードがメールに正常に送信されました",
  "Password Change": "パスワードの変更",
  "Password changed successfully!": "パスワードが正常に変更されました！",
  "Patient": "患者",
  "Patient Information": "患者情報",
  "Payment Methods": "支払い方法",
  "Pharmacies": "薬局",
  "Pharmacy Name": "薬局名",
  "Phone": "電話",
  "Phone No.": "電話番号",
  "Phone Number": "電話番号",
  "Please fix the errors before submitting": "送信前にエラーを修正してください",
  "Please review these interactions before submitting the prescription.": "処方箋を送信する前にこれらの相互作用を確認してください",
  "Please wait while we process your prescription": "処方箋の処理中ですので、しばらくお待ちください",
  "Postal Code": "郵便番号",
  "Potential Drug Interactions Detected": "潜在的な薬物相互作用が検出されました",
  "Prescription": "処方箋",
  "Prescription History": "処方履歴",
  "Price": "価格",
  "Category": "カテゴリー",
  "Primary Image": "メイン画像",
  "Product Code": "商品コード",
  "Product ID": "商品ID",
  "Product Name": "商品名",
  "Product published successfully!": "商品の公開に成功しました！",
  "Profile": "プロフィール",
  "Profile updated successfully!": "プロフィールの更新に成功しました！",
  "Profile updated successfully": "プロフィールの更新に成功しました！",
  "Publish Product": "商品の公開",
  "Q:": "Q:",
  "Question": "質問",
  "Recent Payment Activity": "最近の支払い状況",
  "Remove medication": "薬を削除",
  "Reported Symptoms": "申告された症状",
  "Reset Password": "パスワードをリセット",
  "Retry": "再試行",
  "Retry Loading": "再読み込み",
  "Search doctors...": "医師を検索...",
  "Select Package": "パッケージを選択",
  "Select Pharmacy*": "薬局を選択*",
  "Select Time (24-hour format):": "時間 (24時間形式)を選択：",
  "Select a past date to view history": "履歴を表示するために過去日付を選択",
  "Select duration": "期間を選択",
  "Select frequency": "頻度を選択",
  "Select or type medicine name": "薬剤名を選択または入力",
  "Settings": "設定",
  // "Shop Japan Logo": "Shop Japanのロゴ",
  "Shop Japan Logo": "ショップジャパンのロゴ",
  "Shop Japan": "ショップジャパン",
  "Slot Duration (minutes):": "スロット時間（分）：",
  "Slot count:": "スロット数：",
  "Slot updated successfully": "スロットの更新成功",
  "Slots Booked": "予約済みスロット",
  "Specialty": "専門分野",
  "Start Date": "開始日",
  "Status": "ステータス",
  "Tell us about your clinic...": "クリニックについて教えてください...",
  "This patient has no previous prescriptions.": "この患者には過去の処方箋がありません",
  "To:": "終了時刻：",
  "Today": "本日",
  "Total Coupons": "合計クーポン",
  "Total Doctors": "合計の医師",
  "Total Pharmacies": "合計薬局",
  "Total Usage": "合計使用量",
  "Transaction": "取引",
  "Try adjusting your search terms.": "検索条件を調整してみてください",
  "UNREAD": "未読",
  "Untitled": "無題",
  "Unsaved Changes": "保存されていない変更",
  "Update doctor information": "医師情報の更新",
  "Upload Image": "画像のアップロード",
  "Upload Image for the Clinic": "クリニックの画像をアップロード",
  "Verification Code": "確認コード",
  "Videos": "ビデオ",
  "View Profile": "プロフィールを見る",
  "We'll send you an OTP to verify your identity": "本人確認のため、ワンタイムパスワードをお送りします",
  "Website": "ウェブサイト",
  "Weight (kg)": "体重(kg)",
  "You have unsaved changes. Are you sure you want to cancel? All changes will be lost.": "保存されていない変更があります。キャンセルしてもよろしいですか？すべての変更が失われます",
  "images": "画像",
  "or": "または",
  "primary": "主要な",
  "Here you can manage all prescriptions": "ここで全ての処方箋を管理できます",
  "Manage and View all Patient information": "すべての患者情報を管理および表示する",
  "Manage and View all Appointments and Slots": "すべての予約とスロットを管理および表示する",
  "Manage and View all Doctors associated with your clinic": "クリニックに関連するすべての医師を管理および表示する",
  "Manage and View all Pharmacies associated with your clinic": "クリニックに関連するすべての薬局を管理および表示する",
  "Manage and View all Coupons associated with your clinic": "クリニックに関連するすべてのクーポンを管理および表示する",
  "Prescription API modified": "処方APIが変更されました",
  "Manage and update your account settings": "アカウント設定の管理と更新",
  "Doctors": "医師",
  "Appointments & Slots": "予約とスロット",
  "Billing & Payments": "請求と支払い",
  "Manage and View all Billing and Payments": "すべての請求と支払いを管理および表示する",
  "Bookings": "予約",
  "Manage and View all Bookings": "すべての予約を管理および表示する",
  "Manage and view your profile information": "プロフィール情報の管理と表示",
  "Welcome, {name}!": "{name}さん、ようこそ！",
  "Dashboard": "ダッシュボード",
  "Booking Management": "予約管理",
  "Patient Management": "患者管理",
  "Doctor Management": "医師管理",
  "Prescription Management": "処方管理",
  "Error loading dashboard data": "ダッシュボードデータの読み込みエラー",
  "Dashboard Overview": "ダッシュボード概要",
  "Total Patients": "患者総数",
  "Registered patients": "登録済みの患者",
  "Total Appointments": "予約総数",
  "for today": "本日の件数",
  "Total Revenue": "総収益",
  "Total earnings": "総売上",
  "No Data Available": "データがありません",
  "Start adding patients and scheduling appointments to see your dashboard metrics.":
    "患者の追加と予約の登録を行うと、ダッシュボード指標が表示されます。",
  "For today's slots, minimum time must be": "本日のスロットは、最低時刻が必要です：",
  "From time is required": "開始時刻は必須です",
  "To time is required": "終了時刻は必須です",
  "Slot count must be greater than 0": "スロット数は0より大きい必要があります",
  "Slot duration must be greater than 0": "スロット時間は0より大きい必要があります",
  "To time must be after from time": "終了時刻は開始時刻より後でなければなりません",
  "Saving...": "保存中...",
  "Updating...": "更新中...",
  "Save Changes": "変更を保存",
  "Available Slots:": "利用可能なスロット：",
  "Date:": "日付：",
  "No date selected": "日付が選択されていません",
  "(Past)": "（過去）",
  "DONE": "完了",
  "FULL": "満席",
  "Unknown Patient": "不明な患者",
  "No email": "メールなし",
  "No contact": "連絡先なし",
  "Online": "オンライン",
  "Offline": "オフライン",
  "Mins": "分",
  "Save": "保存",
  "Search patients...": "患者を検索...",
  "Patient ID": "患者ID",
  "Date of Birth": "生年月日",
  "Last Visit": "最終受診",
  "Consult Type": "診療タイプ",
  "Male": "男性",
  "Female": "女性",
  "Error fetching patients": "患者データの取得エラー",
  "Showing": "表示中",
  "of": "の",
  "No Patients Found": "患者が見つかりません",
  "No patients match your current filters. Try adjusting your search criteria.": "現在のフィルターに一致する患者はいません。検索条件を調整してください。",
  "No patients have been added to the system yet.": "システムに患者はまだ登録されていません。",
  "Clear All Filters": "すべてのフィルターをクリア",
  "Patient Details": "患者詳細",
  "Patient ID:": "患者ID：",
  "Details": "詳細",
  "Health Assessment": "健康評価",
  "Notes": "メモ",
  "Other": "他の",
  "Prefer not to say": "回答しない",
  "Medical Information": "医療情報",
  "No medical information available.": "医療情報はありません。",
  "Height": "身長",
  "Weight": "体重",
  "BMI": "BMI",
  "Symptoms": "症状",
  "Underweight": "低体重",
  "Normal": "標準",
  "Overweight": "過体重",
  "Obese": "肥満",
  "Initial Health Assessment": "初回健康評価",
  "Final Consultation Assessment": "最終診察評価",
  "No response provided": "回答はありません",
  "No health assessment data available.": "健康評価データはありません。",
  "Doctor's Notes": "医師のメモ",
  "Target weight appears dangerously low. Medical review recommended.": "目標体重が危険なほど低い可能性があります。医師の確認を推奨します。",
  "High blood pressure reported in young patient.": "若年患者で高血圧が報告されています。",
  "Bookings for {date}": "【{date}】の予約一覧",
  "Patient Id:": "患者ID:",
  "Accept": "承認",
  "Decline": "却下",
  "Auto Approved": "自動承認",
  "Appointment Completed": "診療完了",
  "Accepted": "承認済み",
  "Join Call": "通話に参加",
  "Cancelled": "キャンセル済み",
  "Rescheduled": "日程再調整",
  "Notifications": "通知",
  "Loading notifications...": "通知を読み込み中...",
  "No notifications yet": "まだ通知はありません",
  "We'll notify you when something important happens": "重要なお知らせがある場合に通知します",
  "Prescriptions": "処方箋一覧",
  "Clinic Management": "クリニック管理",
  "No Bookings Found": "予約はありません",
  "No appointments were scheduled for {date}": "{date} の予約はありませんでした",
  "No appointments scheduled for {date}.": "{date} の予約はありません。",
  "Try selecting a different date or": "別の日付を選択するか、",
  "Auto Approve slot": "自動承認スロット",
  "Showing {{from}}-{{to}} of {{total}}": "表示：{{from}}~{{to}} / 全{{total}}件",
  "Total Processed": "処理済み合計",
  "Pending Payments": "保留中の支払い",
  "Failed Payments": "失敗した支払い",
  "Success Rate": "成功率",
  "Edit Slot - ": "スロット編集 - ",
  "Credit Card": "クレジットカード",
  "Primary payment method": "主要なお支払い方法",
  "Search transactions...": "取引を検索...",
  "Invoice": "請求書",
  "Download Receipt": "領収書をダウンロード",
  "View Details": "詳細を表示",
  "Product Details": "商品詳細",
  "View Type": "表示タイプ",
  "View type is required": "表示タイプは必須です",
  "Warranty": "保証",
  "Shop": "ショップ",
  "In Stock": "在庫あり",
  "Out of Stock": "在庫切れ",
  "Photos": "写真",
  "Video": "ビデオ",
  "Manual": "取扱説明書",
  "No images available": "画像はありません",
  "No video available": "利用できるビデオはありません",
  "No manual available": "マニュアルはありません",
  "Tax included": "税込",
  "Product Description": "商品の詳細",
  "FAQ": "よくある質問",
  "Related Products": "関連商品",
  "Failed to fetch product details": "商品詳細の取得に失敗しました",
  "Package A": "パッケージ A",
  "Package B": "パッケージ B",
  "Package C": "パッケージ C",
  "Package D": "パッケージ D",
  "Package E": "パッケージ E",
  "Package F": "パッケージ F",
  "Package G": "パッケージ G",
  "Package": "パッケージ",
  "Custom": "カスタム",
  "Creating...": "作成中...",
  "Medications": "処方薬",
  "Change Patient": "患者を変更",
  "Search prescriptions...": "処方箋を検索...",
  "All Time": "全期間",
  "Last 7 days": "直近7日間",
  "Last 30 days": "直近30日間",
  "No Patients Available": "利用可能な患者がいません",
  "Select Patient to Continue": "続行するには患者を選択してください",
  "Please select a patient from your appointment list to view their prescription history or create new prescriptions.": "処方履歴を表示するか新しい処方箋を作成するには、予約一覧から患者を選択してください。",
  "Select Patient": "患者を選択",
  "Go Back": "戻る",
  "Need help? Try these options:": "お困りですか？次のオプションをお試しください：",
  "Refresh List": "一覧を更新",
  "View Appointments": "予約を表示",
  "Loading patients...": "患者を読み込み中...",
  "Patient ID not found": "患者IDが見つかりません",
  "Failed to load prescription history": "処方履歴の読み込みに失敗しました",
  "You do not have permission to view pharmacies": "薬局を表示する権限がありません",
  "Failed to load patient list": "患者リストの読み込みに失敗しました",
  "Please fix all validation errors before submitting": "送信前にすべての検証エラーを修正してください",
  "Please select a pharmacy": "薬局を選択してください",
  "Please select a package": "パッケージを選択してください",
  "Confirm Prescription": "処方箋の確認",
  "You are about to create a prescription with the following medications:": "次の薬剤で処方箋を作成しようとしています：",
  "This action cannot be undone. Continue?": "この操作は元に戻せません。続行しますか？",
  "Confirm": "確認する",
  "Processing...": "処理中...",
  "Prescription created successfully!": "処方箋を作成しました！",
  "Invalid prescription data. Please check all fields.": "処方箋のデータが無効です。すべての項目を確認してください。",
  "You do not have permission to create prescriptions.": "処方箋を作成する権限がありません。",
  "Patient or pharmacy not found.": "患者または薬局が見つかりません。",
  "Action": "操作",
  "No patients match your search criteria": "検索条件に一致する患者はいません",
  "Select": "選択",
  "ID:": "ID：",
  "Once daily": "1日1回",
  "Twice daily": "1日2回",
  "Three times daily": "1日3回",
  "Four times daily": "1日4回",
  "Every 8 hours": "8時間ごと",
  "Every 12 hours": "12時間ごと",
  "As needed": "必要に応じて",
  "Weekly": "毎週",
  "3 days": "3日間",
  "5 days": "5日間",
  "7 days": "7日間",
  "10 days": "10日間",
  "14 days": "14日間",
  "21 days": "21日間",
  "30 days": "30日間",
  "3 months": "3か月",
  "Remove Medication": "薬を削除",
  "Are you sure you want to remove this medication from the prescription?": "この薬を処方から削除してもよろしいですか？",
  "Dose is required": "用量は必須です",
  "Invalid dose format. Use format like \"5mg\", \"2.5ml\", \"10units\"": "用量の形式が無効です。「5mg」「2.5ml」「10units」のように入力してください",
  "Dose must be greater than 0": "用量は0より大きい必要があります",
  "Dose seems unusually high. Please verify": "用量が異常に多いようです。確認してください",
  "Medicine name is required": "薬剤名は必須です",
  "Medicine name too short": "薬剤名が短すぎます",
  "Medicine name too long": "薬剤名が長すぎます",
  "Medicine name cannot be only numbers": "薬剤名を数字だけにすることはできません",
  "Frequency is required": "頻度は必須です",
  "Duration is required": "期間は必須です",
  "Increased bleeding risk": "出血リスクの増加",
  "Risk of lactic acidosis": "乳酸アシドーシスのリスク",
  "Risk of hyperkalemia": "高カリウム血症のリスク",
  "Address not available": "住所は利用できません",
  "Failed to load patient address": "患者住所の読み込みに失敗しました",
  "Loading address...": "住所を読み込み中...",
  "No symptoms recorded": "症状の記録はありません",
  "Welcome Back": "お帰りなさい",
  "Enter your email and password to access your account": "メールアドレスとパスワードを入力してアカウントにアクセスしてください",
  "Username": "ユーザー名",
  "Enter your Login ID": "ログインIDを入力してください",
  "Password": "パスワード",
  "Enter your password": "パスワードを入力してください",
  "Remember me": "ログイン状態を保持する",
  "Forgot Password": "パスワードをお忘れですか？",
  "Signing In .....": "サインイン中 .....",
  "Sign In": "サインイン",
  "Verify Account": "アカウントを確認",
  "Verify your account to complete the login process": "アカウントを確認してログインを完了してください",
  "Enter your email to receive a password reset code": "パスワードリセットコードを受け取るにはメールアドレスを入力してください",
  "Send OTP": "OTPを送信",
  "Send Reset Code": "リセットコードを送信",
  "Enter OTP": "OTPを入力",
  "Enter the OTP sent to your email for account verification": "アカウント確認のためメールに送信されたOTPを入力してください",
  "SJ Clinic Portal": "SJクリニックポータル",
  "Clinic name is required": "クリニック名は必須です",
  "Email is required": "メールアドレスは必須です",
  "Invalid email format": "無効なメールアドレス形式です",
  "Phone number is required": "電話番号は必須です",
  "Clinic address is required": "クリニック住所は必須です",
  "Failed to load Google Maps": "Google Mapsの読み込みに失敗しました",
  "Failed to initialize map": "マップの初期化に失敗しました",
  "Google Maps failed to initialize properly": "Google Mapsの初期化が正常に完了しませんでした",
  "Failed to load Google Maps script": "Google Mapsスクリプトの読み込みに失敗しました",
  "Failed to update profile. Please try again.": "プロフィールの更新に失敗しました。もう一度お試しください。",
  "Update profile": "プロフィールを更新",
  "Email is invalid": "無効なメールアドレスです",
  "Please enter all 6 digits": "6桁すべてを入力してください",
  "New password is required": "新しいパスワードは必須です",
  "Password must be at least 6 characters": "パスワードは6文字以上である必要があります",
  "Confirm password is required": "パスワード確認は必須です",
  "Passwords do not match": "パスワードが一致しません",
  "Failed to send OTP. Please try again.": "OTP送信に失敗しました。もう一度お試しください。",
  "Failed to change password. Please try again.": "パスワード変更に失敗しました。もう一度お試しください。",
  "Sending OTP...": "OTP送信中...",
  "Changing Password...": "パスワード変更中...",
  "Error Updating Status": "ステータス更新エラー",
  "Try Again": "再試行",
  "Status Updated Successfully!": "ステータスの更新が成功しました！",
  "The prescription has been marked as dispatched.": "処方箋が発送済みとしてマークされました。",
  "Current Status: Dispatched": "現在のステータス：発送済み",
  "Order is on the way to destination": "注文は目的地に向かっています",
  "Prescription Order Ready": "処方箋注文準備完了",
  "Update the delivery status for this prescription": "この処方箋の配送ステータスを更新",
  "Ready for Dispatch": "発送準備完了",
  "A prescription order is ready to be dispatched.": "処方箋注文の発送準備が整いました。",
  "Click the button below to update the delivery status to \"Dispatched\"": "下のボタンをクリックして配送ステータスを「発送済み」に更新してください",
  "Update Status": "ステータス更新",
  "Updating Status...": "ステータス更新中...",
  "Test User": "テストユーザー",
  "User Management": "ユーザー管理",
  "Pharmacy Management": "薬局管理",
  "Coupon Management": "クーポン管理",
  "Products": "製品",
  "Orders": "注文",
  "Stores": "店舗",
  "Welcome": "ようこそ",
  "Manage and View all Clinic information": "すべてのクリニック情報を管理および表示する",
  "Manage and View all User information": "すべてのユーザー情報を管理および表示する",
  "Manage and View all Reports": "すべてのレポートを管理および表示する",
  "Manage and View all Products": "すべての商品を管理および表示する",
  "Manage and View all Orders": "すべての注文を管理および表示する",
  "Manage and monitor all registered Pharmacies": "登録されたすべての薬局を管理および監視する",
  "Manage your discount campaigns": "割引キャンペーンを管理する",
  "Manage your physical store locations": "実店舗の場所を管理する",
  "Manage your Notifications": "通知を管理する",
  "Clinic schedule for today is updated. Check the new appointment slots": "本日のクリニックスケジュールが更新されました。新しい予約枠を確認してください",
  "A product is out of stock. Please update the inventory or notify the relevant team": "商品の在庫が切れています。在庫を更新するか、関連チームに通知してください",
  "Alert: Appointment with 'David Brown' has been rescheduled to 4:00 PM due to doctor unavailability": "アラート：医師の都合により「David Brown」との予約が午後4時に変更されました",
  "Clear All clicked": "すべてクリアがクリックされました",
  "September": "9月",
  "January": "1月",
  "February": "2月",
  "March": "3月",
  "April": "4月",
  "May": "5月",
  "June": "6月",
  "July": "7月",
  "August": "8月",
  "October": "10月",
  "November": "11月",
  "December": "12月",
  "Active Clinics": "アクティブなクリニック",
  "Inactive Clinics": "休止中のクリニック",
  "Add Clinic": "クリニックを追加",
  "Update Clinic": "クリニックを更新",
  "Edit Clinic": "クリニックを編集",
  "Deactivate Clinic": "クリニックを無効化",
  "Clinic status updated to": "クリニックステータスが次に更新されました：",
  "User deleted successfully": "ユーザーが正常に削除されました",
  "Error deleting user:": "ユーザー削除エラー：",
  "NA": "該当なし",
  "No, Keep": "いいえ、保持",
  "reactivating": "再有効化",
  "deactivating": "無効化",
  "the account": "アカウント",
  "This action can be reversed later by": "この操作は後で次の方法で元に戻すことができます：",
  "Are you sure you want to": "本当に次の操作を実行しますか：",
  "Deactivate Pharmacy": "薬局を無効化",
  "Activate Pharmacy": "薬局を有効化",
  "Registered": "登録済み",
  "ACTIVE": "アクティブ",
  "INACTIVE": "非アクティブ",
  "All": "すべて",
  "Update Pharmacy": "薬局を更新",
  "EXPIRED": "期限切れ",
  "Update Coupon": "クーポンを更新",
  "Create Coupon": "クーポンを作成",
  "Deactivate Coupon": "クーポンを無効化",
  "Activate Coupon": "クーポンを有効化",
  "Yes,": "はい、",
  "Role": "役割",
  "Total Spent": "総支出額",
  "Patients": "患者",
  "Monthly Revenue": "月間売上",
  "Sold": "販売済み",
  "Rating": "評価",
  "Store Name": "店舗名",
  "Location": "場所",
  "Revenue": "売上",
  "Order ID": "注文ID",
  "Total Amount": "合計金額",
  "Order Date": "注文日",
  "Payment Method": "支払い方法",
  "Payment Status": "支払いステータス",
  "Total Users": "総ユーザー数",
  "Active Users": "アクティブユーザー",
  "Pending Orders": "保留中の注文",
  "Report": "レポート",
  "Update Product": "商品を更新",
  "Upload Product": "商品をアップロード",
  "This Month's Revenue": "今月の売上",
  "Uploaded This Month": "今月アップロード済み",
  "Add New Clinic": "新しいクリニックを追加",
  "Delete": "削除",
  "Are you sure you want to delete the user": "ユーザーを削除してもよろしいですか？",
  "This action cannot be undone.": "この操作は取り消せません。",
  "Confirm Delete": "削除を確認",
  "Add New Pharmacy": "新しい薬局を追加",
  "Edit Pharmacy": "薬局を編集",
  "Inactive Coupons": "無効なクーポン",
  "Discount": "割引",
  "Minimum Order": "最低注文額",
  "Created": "作成日",
  "Add New Coupon": "新しいクーポンを追加",
  "Reports": "レポート",
  "Users": "ユーザー",
  "Clinics": "クリニック",
  "User Name": "ユーザー名",
  "Available": "利用可能",
  "Not Available": "利用不可",
  "Order Management": "注文管理",
  "Store Management": "店舗管理",
  "Product Management": "商品管理",
  "All order": "すべての注文",
  "Order Id": "注文ID",
  "Product": "製品",
  "Total Order Amount": "注文合計金額",
  "Payment": "支払い",
  "Paid": "支払い済み",
  "Unpaid": "未払い",
  "COMPLETED": "完了",
  "Total Notifications": "通知総数",
  "Sent This Month": "今月送信済み",
  "Add New Notification": "新しい通知を追加",
  "Promotional": "プロモーション",
  "Transactional": "取引関連",
  "Title": "タイトル",
  "Type": "タイプ",
  "Recipients": "受信者",
  "Sent Date": "送信日",
  "1. Content": "1. コンテンツ",
  "2. Audience": "2. オーディエンス",
  "Notification Title": "通知タイトル",
  "Message": "メッセージ",
  "Newsletter": "ニュースレター",
  "Preview": "プレビュー",
  "Your notification message will appear here...": "ここに通知メッセージが表示されます...",
  "Target Audience": "対象オーディエンス",
  "All Users": "すべてのユーザー",
  "All Clinics": "すべてのクリニック",
  "Estimated Reach": "推定リーチ",
  "This notification will be sent to approximately": "この通知はおよそ次に送信されます",
  "clinics": "クリニック",
  "users": "ユーザー",
  "Create Notification": "通知を作成",
  "Update Notification": "通知を更新",
  "Title is required": "タイトルは必須です",
  "Message is required": "メッセージは必須です",
  "Type is required": "タイプは必須です",
  "Audience is required": "オーディエンスは必須です",
  "Notification updated successfully": "通知が正常に更新されました",
  "Notification created successfully": "通知が正常に作成されました",
  "Something went wrong.": "エラーが発生しました。",
  "Edit Notification": "通知を編集",
  "Send": "送信",
  "Draft": "下書き",
  "Deactivate Notification": "通知を無効化",
  "Active Stores": "アクティブ店舗",
  "Inactive Stores": "非アクティブ店舗",
  "Avg Revenue/Store": "店舗あたり平均収益",
  "Store Locations": "店舗の場所",
  "Store List": "店舗一覧",
  "Click on any store to see location on map": "地図で場所を確認するには、任意の店舗をクリックしてください",
  "Loading stores...": "店舗を読み込み中...",
  "Failed to fetch stores": "店舗の取得に失敗しました",
  "No stores available": "利用可能な店舗はありません",
  "Store Location Map": "店舗の位置マップ",
  "Map showing all store locations with pins. Click on pins to highlight store details": "ピンで全ての店舗の場所を表示します。ピンをクリックして店舗の詳細を確認できます",
  "Loading map...": "マップを読み込み中...",
  "Deactivate Store": "店舗を無効化",
  "Activate Store": "店舗を有効化",
  "Could not geocode address": "住所のジオコーディングに失敗しました",
  "Add New Store": "新しい店舗を追加",
  "Edit Store": "店舗を編集",
  "Company Name": "会社名",
  "Prefectures": "都道府県",
  "Interactive map will show here. Drag pin to set exact location": "ここにインタラクティブマップが表示されます。ピンをドラッグして正確な位置を設定してください",
  "Post Code": "郵便番号",
  "Operating Hours": "営業時間",
  "Coordinates": "座標",
  "Update Store": "店舗を更新",
  "Create Store": "店舗を作成",
  "Company name is required": "会社名は必須です",
  "Store name is required": "店舗名は必須です",
  "Address is required": "住所は必須です",
  "Prefectures is required": "都道府県は必須です",
  "Postal code is required": "郵便番号は必須です",
  "Opening time is required": "営業時間（開始）は必須です",
  "Closing time is required": "営業時間（終了）は必須です",
  "Product name is required": "商品名は必須です",
  "Description is required": "説明は必須です",
  "Product code is required": "商品コードは必須です",
  "Price is required": "価格は必須です",
  "Price must be a number": "価格は数字である必要があります",
  "Product updated successfully!": "商品が正常に更新されました！",
  "Product added successfully!": "商品が正常に追加されました！",
  "Failed to save product": "商品を保存できませんでした",
  "Welcome, Admin": "ようこそ、管理者",
  "Welcome,": "ようこそ、",
  "SJ Admin Portal": "SJ管理ポータル",
  "Medical Illustration": "医療イラスト",
  "Decorative Pattern": "装飾パターン",
  "Username is required": "ユーザー名は必須です",
  "Username must be at least 3 characters": "ユーザー名は3文字以上である必要があります",
  "Password is required": "パスワードは必須です",
  "Password must contain at least one capital letter and one digit": "パスワードには少なくとも1つの大文字と1つの数字を含める必要があります",
  "Password must contain at least one capital letter": "パスワードには少なくとも1つの大文字を含める必要があります",
  "Password must contain at least one digit": "パスワードには少なくとも1つの数字を含める必要があります",
  "Successfully Logged In": "ログインに成功しました",
  "Something went wrong. Please try again.": "エラーが発生しました。もう一度お試しください。",
  "OTP sent to registered email address": "登録したメールアドレスにOTPが送信されました",
  "Incorrect details": "詳細が正しくありません",
  "Password has been reset successfully": "パスワードが正常にリセットされました",
  "Password could not be updated!": "パスワードを更新できませんでした！",
  "Enter email": "メールを入力",
  "Enter your email to reset your password": "パスワードをリセットするためにメールを入力してください",
  "Get Code": "コードを取得",
  "Enter the verification code sent to your email and set your new password": "メールに送信された確認コードを入力し、新しいパスワードを設定してください",
  "Clinic Availability Report": "クリニック利用可能状況レポート",
  "Available Slots": "利用可能スロット",
  "Slot Utilization": "スロット利用率",
  "Coupon name is required": "クーポン名は必須です",
  "Coupon code is required": "クーポンコードは必須です",
  "Discount value is required": "割引金額は必須です",
  "Minimum order value is required": "最低注文金額は必須です",
  "Start date is required": "開始日は必須です",
  "End date is required": "終了日は必須です",
  'Pharmacy name is required': '薬局名は必須です',
  'City is required': '市区町村は必須です',
  'Enter only numbers': '数字のみを入力してください',
  'Enter a valid email address': '有効なメールアドレスを入力してください',
  "Availability": "利用可能状況",
  "Clinic updated successfully": "クリニックが正常に更新されました",
  "Clinic added successfully": "クリニックが正常に追加されました",
  "Pharmacy updated successfully": "薬局が正常に更新されました",
  "Pharmacy added successfully": "薬局が正常に追加されました",
  "Coupon updated successfully": "クーポンが正常に更新されました",
  "Coupon created successfully": "クーポンが正常に作成されました",
  "Store updated successfully": "店舗が正常に更新されました",
  "Store added successfully": "店舗が正常に追加されました",
  "Product updated successfully": "商品が正常に更新されました",
  "Product added successfully": "商品が正常に追加されました",
  "SJ - Admin Portal": "SJ - 管理ポータル",
  "You need to enable JavaScript to run this app.": "このアプリを実行するには JavaScript を有効にしてください",
  "Home": "ホーム",
  "Pharmacy": "薬局",
  "Login": "ログイン",
  "Questions Answered by User on App": "アプリでユーザーが回答した質問",
  "Search by Customer Email": "顧客メールで検索",
  "Select Customer by Email": "メールで顧客を選択",
  "Select All": "すべて選択",
  "View All": "すべて表示",
  "more": "さらに",
  "Customer": "顧客",
  "All Customers": "全ての顧客",
  "From": "開始",
  "To": "終了",
  "Customer Type": "顧客タイプ",
  "Health Customer": "健康顧客",
  "Non-Health Customer": "非健康顧客",
  "Product deleted successfully": "製品が正常に削除されました。",
  "Are you sure you want to delete the product": "製品を削除してもよろしいですか",
  "2. Customer": "2. 顧客",
  "Customers": "顧客",
  "Please select at least one customer email": "少なくとも1つの顧客のメールを選択してください",
  "Notification sent successfully": "通知が正常に送信されました",
  "Failed to send notification": "通知の送信に失敗しました",
  "Pharmacy status updated to": "薬局のステータスが更新されました",
  "Failed to fetch pharmacies": "薬局の取得に失敗しました",
  "Error updating profile": "プロフィールの更新中にエラーが発生しました",
  "Error updating profile:": "プロフィールの更新中にエラーが発生しました:",
  "Notification deleted successfully": "通知が正常に削除されました",
  "Error deleting notification:": "通知の削除中にエラーが発生しました：",
  "Failed to delete notification": "通知の削除に失敗しました",
  "Store status updated to": "店舗のステータスが更新されました",
  "BMI Status": "BMIの状態",
  "Select BMI": "BMIを選択",
  "Above 28": "28超",
  "Above 32": "32超",
  "Above 36": "36超",
  "Above 40": "40超",
  "Select Age": "年齢を選択",
  "Above 18": "18歳以上",
  "Above 25": "25超",
  "Reset Filters": "フィルターをリセット",
  "Loading...": "読み込み中...",
  "No data found": "データが見つかりません",
  "BMI_Status_Report": "BMIステータスレポート",
  "Banner Management": "バナー管理",
  "Manage your Banner": "バナーを管理する",
  "Add New Banner": "新しいバナーを追加",
  "Banner Name": "バナー名",
  "Edit Banner": "バナーを編集",
  "Deactivate Banner": "バナーを削除",
  "Are you sure you want to delete the banner": "このバナーを削除してもよろしいですか",
  "Banner deleted successfully": "バナーが正常に削除されました",
  "Failed to delete banner": "バナーの削除に失敗しました",
  "Banner Title": "バナーのタイトル",
  "Close": "閉じる",
  "Drop image here or browse": "画像をここにドロップするか、参照してください",
  "Recommended: 800x400px, Max 2MB (PNG only)": "推奨サイズ: 800x400px、最大 2MB（PNG のみ）",
  "Banner image is required (PNG up to 2MB)": "バナー画像は必須です（PNG 最大 2MB）",
  "Only PNG images up to 2MB are allowed": "PNG 形式で 2MB 以下の画像のみアップロード可能です",
  "Destination URL": "リンク先 URL",
  "Live Preview": "ライブプレビュー",
  "Banner Title Placeholder": "バナーのタイトル",
  "Banner description goes here": "ここにバナーの説明を入力してください",
  "Order Now": "今すぐ注文",
  "All Services Available | T&C Applied": "全てのサービスが利用可能 | 利用規約が適用されます",
  "Color Style": "カラースタイル",
  "Create": "作成",
  "Update Banner": "バナーを更新",
  "Banner added successfully": "バナーが正常に追加されました",
  "Banner updated successfully": "バナーが正常に更新されました",
  "Banner title is required": "バナーのタイトルは必須です",
  "Destination URL is required": "リンク先 URL は必須です",
  "No image selected": "画像が選択されていません",
  "Services": "サービス",
  "Badge": "バッジ",
  "Above 30": "30歳以上",
  "Above 35": "35歳以上",
  "Download": "ダウンロード",
  "Manage Warranty Management": "保証管理を管理",
  "Warranty Management": "保証管理",
   "Total Registrations": "総登録数",
  "Health Questionnaire Completions": "健康アンケート完了数",
  "Consultations Booked": "予約済み相談数",
  "Consultations Completed": "完了した相談数",
  "Total Prescriptions": "処方箋合計",
  "Prescription Sales": "処方箋売上",
  "Total Retail Orders": "小売注文合計",
  "Retail Sales": "小売売上",
  "Warranty Registrations": "保証登録数",
  "Label": "ラベル",
  "Value": "値",
  "Export Cards (CSV)": "カードをエクスポート（CSV）",
  "All_Cards_Report": "すべてのカード_レポート",
  "Loading": "読み込み中",
  "Search": "検索",
  "Export": "エクスポート",
  "InActive": "非アクティブ",
  "Warranty Registration Details": "保証登録の詳細",
  "User Information": "ユーザー情報",
  "Purchase date": "購入日",
  "Product Information": "製品情報",
  "Product name": "製品名",
  "Product code": "製品コード",
  "Purchase Information": "購入情報",
  "Purchase Date": "購入日",
  "Date Registered": "登録日",
  "Purchase Cost": "購入価格",
  "Proof of Purchase": "購入証明",
  "No file uploaded": "ファイルはアップロードされていません",
  "receipt": "領収書",
  "Warranty Report": "保証レポート",
  "Total Warranties": "保証総数",
  "-": "-",
  "Completed Appointments": "完了した予約数",
  "Total Prescription Aamount": "総処方箋金額", 
  "Total Retail Orders Sales": "小売注文売上総額",
  "Number of Registrations": "登録数",
  "Number of users who completed health questions": "健康に関する質問に回答したユーザーの数",
  "Number of Active Users" : "アクティブユーザー数",
  "Number of Consultations booked": "予約された相談の数",
  "Number of Consultations completed": "完了した相談件数",
  "Number of Prescriptions": "処方箋の数",
  "Number of Total Prescription Amount": "処方箋総数",
  "Number of Retails orders": "小売注文数",
  "Number of Total Retail sales": "総小売売上高",
  "Number of Retail Product Warranty Registrations": "小売製品保証登録数",
  "Total Clinics": "トータルクリニック",
  "Total Products": "総製品数",
  "Total Stores" : "総店舗数",
  "Total Orders": "総注文数",
  "High BMI Status" : "高BMIステータス",
  "Total Prescription Amount value": "処方箋合計金額",
  "Filter" : "フィルター",
  "Filter Type": "フィルターの種類",
  "MONTHLY": "毎月",
  "DATE RANGE": "日付範囲",
  "Select Month": "月を選択してください",
  "Month": "月",
  "Select Date Range": "日付範囲の選択",
  "Clear Filters":"フィルターをクリアする",
  "Filter applied:" : "適用されたフィルター:",
  "Selected month cannot be in the future": "選択した月は将来の月にはできません",
  "Start date cannot be in the future": "開始日は将来の日付にできません",
  "End date cannot be in the future": "終了日は将来の日付にできません",
  "End date cannot be before start date" : "終了日は開始日より前に設定できません",
  "Reject Warranty": "保証を拒否する",
  "Approve Warranty": "保証を承認する",
  "Rejected": "拒否されました",
  "Approved": "承認された",
  "Approve": "承認する",
  "Reject": "拒否する",
  "Yes, Approve": "はい、承認します",
  "Yes, Reject": "はい、拒否します",
  "Are you sure you want to approve": "本当に承認しますか",
  "Are you sure you want to reject": "本当に拒否しますか",
  "'s warranty?": "の保証は？",
  "Warranty approved": "保証が承認されました",
  "Warranty rejected": "保証が拒否されました",
  "Admin Management": "管理者管理",
  "Manage admin and permissions": "管理者と権限を管理する",
  "Edit Admin": "管理者の編集",
  "Create New Admin": "新しい管理者の作成",
  "Update": "アップデート",
  "Add a new user and assign them a role. Click save when you're done": "新しいユーザーを追加し、役割を割り当てます。完了したら「保存」をクリックします。",
  "Update Admin": "更新管理者",
  "Something went wrong": "何か問題が発生しました",
  "Enter a valid email": "有効なメールアドレスを入力してください",
  "Last Name is required": "姓は必須です",
  "First Name is required": "名は必須です",
  "Admin updated successfully": "管理者は正常に更新されました",
  "Admin created successfully": "管理者が正常に作成されました",
  "User Name is required": "ユーザー名は必須です",
  "Role is required": "役割は必須です",
  "Only letters are allowed":"文字のみが許可されます",
  "Purchase Store": "購入ストア",
  "Date of Birth": "生年月日",
  "gender": "性別",
  "Gender": "性別",
  "Add a new user and assign them a role. Click save when you're done.": "新しいユーザーを追加し、役割を割り当てます。完了したら「保存」をクリックしてください。",
  "PIN": "ピン",
  "Failed to load profile": "プロフィールの読み込みに失敗しました",
  "Answered Health Questions": "健康に関する質問への回答",
  "Not Answered Health Questions": "健康に関する質問への回答なし",
  "Download Report": "レポートのダウンロード",
  "Health Report": "健康レポート",
  "Minimum 6 characters required": "最低6文字が必要です",
  "Maximum 10 characters allowed": "最大10文字まで使用できます",
  "Enable Admin": "管理者を有効にする",
  "Disable Admin" : "管理者を無効にする",
  "Admin enabled successfully": "管理者が正常に有効になりました",
  "Admin disabled successfully": "管理者は正常に無効になりました",
  "Failed to update status": "ステータスの更新に失敗しました",
  "Health Questions Report": "健康に関する質問レポート",
  "Name is required": "名前は必須です",
  "Registration Date": "登録日",
  "Activate Clinic": "クリニックを活性化する",
  "Coupon status updated to": "クーポンステータスが更新されました",
  "user": "ユーザー",
  "Change Admin Password": "管理者パスワードの変更",
  "Password updated successfully": "パスワードが正常に更新されました",
  "Failed to update password": "パスワードの更新に失敗しました",
  "Email must be a valid @oaklawn.co.jp address":"メールアドレスは有効な@oaklawn.co.jpアドレスである必要があります",
  "Enter your Username": "ユーザー名を入力してください",
  "Confirm Change Password":"パスワード変更の確認",
  "Enter your old password":"古いパスワードを入力してください",
  "Old Password": "以前のパスワード",
  "Please enter your old password and set a new password.":"古いパスワードを入力し、新しいパスワードを設定してください。",
  "Only numeric values are allowed": "数値のみが許可されます",
  "Special characters are not allowed":"特殊文字は使用できません",
  "Please select coupon type": "クーポンの種類を選択してください",
  "Select Coupon Type": "クーポンの種類を選択してください",
  "Are you sure you want to delete the coupon": "クーポンを削除してもよろしいですか",
  "Coupon deleted successfully": "クーポンは正常に削除されました",
  "Failed to delete coupon" : "クーポンの削除に失敗しました",
  "Error deleting Coupon:": "クーポン削除エラー:",
  "Delete Coupon" : "クーポンの削除",
  "Clinic Report": "クリニックレポート",
  "Product Report": "製品レポート",
  "Total Retail sales": "小売総売上高",
  "Prescription Amount": "処方量",
  "Invalid old password": "無効な古いパスワード",
  "Old password is required": "古いパスワードが必要です",
  "Token expired": "トークンの有効期限が切れました",
  "Invalid token": "無効なトークン",
  "Access token expired or invalid. Logging out.": "アクセストークンの有効期限が切れているか、無効です。ログアウトします。",
  "Registration Report": "登録レポート",
  "Search by store name or city": "店舗名または都市で検索",
  "Generate QR Code": "QRコードの生成",
  "QR Code": "QRコード",
  "Delete Product": "製品の削除",
  "Edit Product": "製品の編集",
  "Create and manage deep links for app navigation" : "アプリナビゲーション用のディープリンクを作成および管理する",
  "Deeplink Management": "ディープリンク管理",
  "Add Deep Link": "ディープリンクの追加",
  "Token ID" : "トークンID",
  "Destination Type": "宛先タイプ",
  "Created Date": "作成日",
  "active": "アクティブ",
  "Update Deep Link": "ディープリンクの更新",
  "Create Deep Link": "ディープリンクの作成",
  "Fill in the details to generate a new deep link": "新しいディープリンクを生成するには、詳細を入力してください。",
  "Edit Deep Link": "ディープリンクの編集",
  "Create New Deep Link": "新しいディープリンクの作成",
  "Link copied to clipboard": "リンクがクリップボードにコピーされました",
  "Failed to copy link": "リンクのコピーに失敗しました",
  "Failed to load QR Code" : "QRコードの読み込みに失敗しました",
  "Deep link status updated to": "ディープリンクの状態が更新されました",
  "disabled": "無効",
  "QR not available": "QRは利用できません",
  "Token:" : "トークン：",
  "Deep Link URL": "ディープリンクURL",
  "Copy Link" : "リンクをコピー",
  "Deep Link Name is required": "ディープリンク名は必須です",
  "Destination Type is required": "宛先タイプは必須です",
  "Status is required" :"ステータスは必須です",
  "Deep Link Name": "ディープリンク名",
  "Disabled": "無効",
  "Count": "カウント",
  "Deep link created successfully": "ディープリンクが正常に作成されました",
  "Deep link updated successfully": "ディープリンクが正常に更新されました",
  "Deep link deleted successfully": "ディープリンクが正常に削除されました。",
  "Failed to delete deep link": "ディープリンクの削除に失敗しました",
  "Are you sure you want to delete this deep link": "このディープリンクを削除してもよろしいですか",
  "Edit": "編集",
  "Show QR Code": "QRコードを表示",
  "Delete Link": "リンクを削除",
  "Link Type": "リンクタイプ",
  "Internal": "内部",
  "External": "外部",
  "External Link": "外部リンク",
  "External Link is required": "外部リンクは必須です",
  "External Link must start with http:// or https://": "外部リンクは http:// または https:// で始まる必要があります",
  "QR Type" : "QRタイプ"
};

export default en_ja;